import "card/dist/card.js"

window.onload = function() {
  checkOS()

  checkBrowser()

  const menuButton = document.querySelector('.navbar-toggler')
  const menuContent = document.querySelector('.navbar-collapse')

  menuButton.addEventListener('click', () => {

    menuButton.classList.toggle('active')

    if (menuButton.classList.contains('active') == true) {
      menuContent.classList.remove('show')
    } else {
      menuContent.classList.add('show')
    }
  })

}

function checkOS() { // Check user OS
  if (navigator.platform.match('iPhone|iPad|iPod') !== null) {
    document.body.setAttribute('class', 'ios')
  } else {
    document.body.setAttribute('class', 'default')
  }
}

function checkBrowser() { // Check user Browser
  let isEdge = navigator.userAgent.match('Edge')
  let isIe = navigator.userAgent.match('.NET')

  if (isEdge !== null) {
    document.body.classList.add('edge')
  } else if (isIe !== null) {
    document.body.classList.add('ie')
  } else {}
}

